import { Injectable } from '@angular/core';
import { getSignatories, isGuarantor } from '@core/util/client';
import { getPrimaryParcel } from '@core/util/parcels';
import { Business, BusinessAddress } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
	PersonMatterClientWithAssociations,
	BusinessMatterClientWithAssociations,
	CalculatedLandTransferTax,
	ClientsCapacity,
	MatterTitle,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class MLTT_SUPPLEMENTARY_FORM_Mapper extends BaseFormMapper<MLTT_SUPPLEMENTARY_FORM> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: MLTT_SUPPLEMENTARY_FORM,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
		matterTitles: MatterTitle[],
		matterClients: (
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations
		)[],
		lttCalculated: CalculatedLandTransferTax,
		businessAddress: BusinessAddress,
		otherParties: PersonMatterClient[],
		clientsCapacity: ClientsCapacity,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as MLTT_SUPPLEMENTARY_FORM);

		const FilteredMatterClients =
			matterClients?.filter((client) => !isGuarantor(client)) ?? [];

		const PrimaryClient = FilteredMatterClients?.find(
			(clients) => clients?.primaryContact,
		);

		const ClientsSharesCapacity = clientsCapacity?.shares
			? Object.keys(clientsCapacity?.shares).map((share) => ({
					...clientsCapacity?.shares?.[share],
				}))
			: [];

		const Contacts = getSignatories(FilteredMatterClients);

		const PrimaryTitle = getPrimaryParcel(matterTitles);

		return _formData;
	}

	MapValues(): Partial<MLTT_SUPPLEMENTARY_FORM> {
		return {};
	}
}

const Mappings: MLTT_SUPPLEMENTARY_FORM = {
	propertyAddress: 'Text1',
	instrumentNumber: 'Text2',

	nameOfPurchaser: 'Text3',
	percentageInterest: 'Text4',

	familyLawActCheckbox: 'CC005',
	familyLawActCheckbox2: 'CC006',

	spouseOwnedEligibleHome: 'Group1',

	nameOfSpouse: 'CC007',
	dateOfUnion: 'Text8',
	addressOfPreviouslyOwnedHome: 'Text9',
	datePropertySold: 'Text10',

	residencePropertyAddress: 'Text11',
	dateFrom: 'Text12',
	dateTo: 'Text13',

	residencePropertyAddress2: 'Text14',
	dateFrom2: 'Text15',
	dateTo2: 'Text16',

	residencePropertyAddress3: 'Text17',
	dateFrom3: 'Text18',
	dateTo3: 'Text19',

	residencePropertyAddress4: 'Text20',
	dateFrom4: 'Text21',
	dateTo4: 'Text22',

	residencePropertyAddress5: 'Text23',
	dateFrom5: 'Text24',
	dateTo5: 'Text25',

	date: 'cc088',
};

export interface MLTT_SUPPLEMENTARY_FORM {
	propertyAddress: string;
	instrumentNumber: string;
	nameOfPurchaser: string;
	percentageInterest: string;

	familyLawActCheckbox: string;
	familyLawActCheckbox2: string;

	spouseOwnedEligibleHome: string;

	nameOfSpouse: string;
	dateOfUnion: string;
	addressOfPreviouslyOwnedHome: string;
	datePropertySold: string;

	residencePropertyAddress: string;
	dateFrom: string;
	dateTo: string;

	residencePropertyAddress2: string;
	dateFrom2: string;
	dateTo2: string;

	residencePropertyAddress3: string;
	dateFrom3: string;
	dateTo3: string;

	residencePropertyAddress4: string;
	dateFrom4: string;
	dateTo4: string;

	residencePropertyAddress5: string;
	dateFrom5: string;
	dateTo5: string;

	date: string;
}
